














































































































import { Component, Vue, Ref, PropSync, Prop } from "vue-property-decorator"
import policyService from "@/services/policy.service"
import { FormModel } from "ant-design-vue"
import { cloneDeep, omit } from "lodash"
interface ShowEditModal {
    visible: boolean
    record: any
    list: any[]
    updateText: { id: number; name: ""; en_name: ""; textTips: boolean; en_textTips: boolean }
}
@Component({})
export default class AddOrEditModel extends Vue {
    @PropSync("visible", { default: false })
    visible_: boolean

    @Prop({ type: String, default: "add" })
    markModel: string

    @Prop({ type: Object })
    showEditModal: ShowEditModal

    @Ref("privacyTextForm")
    refFrom: FormModel

    removeDomain(item: number) {
        const index = this.showEditModal.list.indexOf(item)
        if (index !== -1) {
            this.showEditModal.list.splice(index, 1)
        }
    }
    // 添加行
    onClickAddText() {
        this.showEditModal.list.push({
            id: 0,
            name: "",
            en_name: "",
            textTips: false,
            en_textTips: false
        })
    }

    async handleAddOrEdit() {
        this.markModel = "add"
        this.showEditModal.visible = true
    }

    get changeTitle() {
        const title = this.markModel == "add" ? "添加文本类型" : "编辑文本类型"
        return title
    }

    //新增中文，输入框变化时
    itemAddNameChange(index: number) {
        this.showEditModal.list[index].textTips = false
    }

    //新增英文，输入框变化时
    itemAddEn_NameChange(index: number) {
        this.showEditModal.list[index].en_textTips = false
    }

    // 文本重复 进行提示class="textTips"字段隐藏
    promptText(data: any) {
        // 创建一个映射来快速查找校验结果
        const validationResult = new Map(data.map((item: string) => [item[0], item.slice(1)]))
        // 使用 map 方法更新 list
        this.showEditModal.list = this.showEditModal.list.map((item, index) => {
            const result = validationResult.get(index) as [number, number] | undefined
            return {
                ...item,
                textTips: result ? result[0] === 1 : false,
                en_textTips: result ? result[1] === 1 : false
            }
        })
    }

    // 添加文本类型
    async addMode() {
        await this.refFrom.validate()
        const addFromDate = cloneDeep(this.showEditModal)
        const { list } = addFromDate
        const newList = list.map((item: any) => omit(item, "textTips"))
        const payload = { list: newList }
        try {
            const dupArr = await policyService.textTypeCreate(payload)
            if (dupArr.length === 0) {
                this.showEditModal.visible = false
                this.$message.success("创建成功")
                this.$emit("upDataList")
                this.showEditModal.list = [
                    { id: 0, name: "", en_name: "", textTips: false, en_textTips: false }
                ]
            } else {
                this.promptText(dupArr)
            }
        } catch (error) {
            this.$message.error(`创建失败！ ${error}`)
        }
    }
    // 编辑文本类型
    async editMode() {
        try {
            const payload = this.showEditModal.updateText
            await policyService.textTypeUpdate(payload)
            this.showEditModal.visible = false
            this.$message.success("修改成功")
            this.$emit("upDataList")
        } catch (error) {
            this.$message.error(`修改失败！ ${error}`)
        }
    }

    async handleOk() {
        if (this.markModel == "add") {
            this.addMode()
        } else {
            this.editMode()
        }
    }
    cancel() {
        this.visible_ = false
        this.showEditModal.list = [
            { id: 0, name: "", en_name: "", textTips: false, en_textTips: false }
        ]
    }
}
